
export const MAX_FILE_SIZE_MB = 2;
export const ALLOWED_EXTENSIONS = ['.pdf', '.doc', '.docx', '.xls', '.xlsx'];
export const MIN_GUARANTEED_DISCOUNT_PERCENT = 1;

export const THEME_COLORS = {
  primary: '#3b82f6',
  secondary: '#2dd4bf',
  bgDark: '#050505',
  glass: 'rgba(255, 255, 255, 0.03)'
};
